<div class="container">
  <div class="container-header">
    <div class="container-ruta">
      <span (click)="GoHome()">Inicio</span>
    </div>
    <div *ngFor="let section of sections2" [id]="section.id" >
      <div class="container-tittle">
        <img src="assets/icons/Rectangle31.png" alt="*">
        <span class="tittle">{{ section.title }}</span>
      </div>
      <div class="row-container" class="grid-container">
        <ng-container *ngFor="let card of section.cards; let i = index">
          <div class="row-container-column">
            <mat-card [ngClass]="i % 2 === 0 ? 'carda' : 'cardb'">
              <mat-card-content (click)="redirectTo(card.routerLink)">
                <mat-card-title>{{ card.title }}</mat-card-title>
                <mat-card-subtitle class="card-sub-title">{{ card.subtitle }}</mat-card-subtitle>
              </mat-card-content>
            </mat-card>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>